<template>
  <div class="c-common-footer-fixed-no-login">
    <div class="c-common-footer-fixed-no-login__inner">
      <div class="p-sso-logout">
        <h3>SSO Logout</h3>
        <p>正常にログアウトしました。</p>
        <p>ブラウザの「×」(閉じる)ボタンで閉じてください。</p>
      </div>
    </div>
    <TheFooter />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({})
export default class Logout extends Vue {}
</script>

<style lang="scss" scoped></style>
